import React from "react";

export default function VideoViewer({ id, keySet, filePathToSet }) {
  return (
    <video id={id} key={keySet} width="100%" height="100%" controls>
      <source src={filePathToSet} type="video/mp4" />
    </video>
  );
}
